import purchaseOrderService from "../../../../services/procurementService/purchaseOrderService";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CACHE_KEY_PURCHASEORDERS } from "../../../../utils/constants";
import { PurchaseOrderInterface } from "../../../../models/ProcurementModule/PurchateOrder/PurchaseOrder";

interface DeletePurchaseOrderContext {
  previousPurchaseOrders: PurchaseOrderInterface[];
  deletedPurchaseOrder: PurchaseOrderInterface | undefined;
}

const useDeletePurchateOrder = (page: number, pageSize: number) => {
  const queryClient = useQueryClient();

  return useMutation<void, Error, string, DeletePurchaseOrderContext>({
    mutationFn: purchaseOrderService.Remove,

    onMutate: (purchaseOrderId: string) => {
      const previousPurchaseOrders =
        queryClient.getQueryData<PurchaseOrderInterface[]>([
          CACHE_KEY_PURCHASEORDERS,
          page,
          pageSize,
        ]) || [];

      // Optimistically update the cache
      queryClient.setQueryData<PurchaseOrderInterface[]>(
        [CACHE_KEY_PURCHASEORDERS, page, pageSize],
        previousPurchaseOrders.filter(
          (purchaseOrder) => purchaseOrder.id !== purchaseOrderId
        ) // Use statusId to filter
      );

      return {
        previousPurchaseOrders,
        deletedPurchaseOrder: previousPurchaseOrders.find(
          (purchaseOrder) => purchaseOrder.id === purchaseOrderId
        ),
      };
    },

    onError: (error, purchaseOrderId, context) => {
      if (!context) return;

      // Rollback to the previous state in case of error
      queryClient.setQueryData<PurchaseOrderInterface[]>(
        [CACHE_KEY_PURCHASEORDERS, page, pageSize],
        context.previousPurchaseOrders
      );
    },

    onSuccess: () => {
      // Optionally, you could perform additional actions on success
      // For example, invalidating queries or updating other parts of the state
    },
  });
};

export default useDeletePurchateOrder;
